// cart-icon-counter.js — force unified cart count
(function () {
  const CART_BUBBLE_SELECTOR =
    "#cart-icon-bubble .cart-bubble, .pb-unified-nav__cart .cart-bubble, .pb-unified-nav__convert-action-btn--cart .cart-bubble";
  const CART_ICON_SELECTOR =
    "#cart-icon-bubble cart-icon, .pb-unified-nav__cart cart-icon, .pb-unified-nav__convert-action-btn--cart cart-icon";
  const CART_LINK_SELECTOR = ".pb-unified-nav__cart, .pb-unified-nav__convert-action-btn--cart";

  function isUnifiedNavBubble(bubble) {
    return Boolean(
      bubble.closest(".pb-unified-nav__cart") || bubble.closest(".pb-unified-nav__convert-action-btn--cart")
    );
  }

  function updateCounters(cart) {
    const qty = cart?.totalQuantity || 0;

    // Force update Shopify cart bubble
    document.querySelectorAll(CART_BUBBLE_SELECTOR).forEach((bubble) => {
      const textEl = bubble.querySelector(".cart-bubble__text-count");
      const srEl = bubble.querySelector(".visually-hidden");
      const unifiedNavBubble = isUnifiedNavBubble(bubble);

      if (textEl && !unifiedNavBubble) {
        textEl.textContent = qty;
        textEl.classList.toggle("hidden", qty === 0);
      }
      if (bubble) {
        bubble.classList.toggle("visually-hidden", qty === 0);
      }
      if (srEl) {
        srEl.textContent = `Total items in cart: ${qty}`;
      }
    });

    document.querySelectorAll(CART_ICON_SELECTOR).forEach((icon) => {
      icon.classList.toggle("header-actions__cart-icon--has-cart", qty > 0);
    });

    document.querySelectorAll(CART_LINK_SELECTOR).forEach((cartLink) => {
      const label = cartLink.getAttribute("aria-label");
      if (!label) return;
      const baseLabel = label.replace(/:\s*\d+$/, "");
      cartLink.setAttribute("aria-label", `${baseLabel}: ${qty}`);
    });

    // Fallback legacy selectors
    document.querySelectorAll("[data-cart-count], .cart-count").forEach((el) => {
      el.textContent = qty;
      el.classList.toggle("is-empty", qty === 0);
    });

    window.PBDebug?.log("[UnifiedCart][Counter] set to", qty);
  }

  async function refreshCounters() {
    if (!window.PBCart) return;
    try {
      const cart = await window.PBCart.refresh();
      updateCounters(cart);
    } catch (err) {
      console.warn("[CartCounter] refresh failed", err);
    }
  }

  // Listen for unified cart updates
  document.addEventListener("pb:cart:updated", (e) => updateCounters(e.detail.cart));

  // Initial sync
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshCounters);
  } else {
    refreshCounters();
  }
})();
